import type { IObjectSchema } from '@ksyos/koi';
import { Koi } from '@ksyos/koi';

export type Quantity = {
    unit: string | null;
    value: number | null;
};

export function isQuantity(value: unknown): value is Quantity {
    return (
        typeof value === 'object' &&
        value !== null &&
        'unit' in value &&
        (typeof value.unit === 'string' || value.unit === null) &&
        'value' in value &&
        (typeof value.value === 'number' || value.value === null)
    );
}

export function getQuantitySchema({
    isDraft = false,
    isRequired,
    minValue,
    maxValue,
}: {
    isDraft?: boolean;
    isRequired: boolean;
    maxValue?: number;
    minValue?: number;
}): IObjectSchema {
    let unit = Koi.string();
    let value = minValue === undefined ? Koi.number() : Koi.number().min(minValue);
    value = maxValue === undefined ? value : value.max(maxValue);

    if (isDraft || !isRequired) {
        unit = unit.allow(null);
        value = value.allow(null);
    }

    return Koi.object({
        unit,
        value,
    }).error((errors) =>
        errors.map((error) => {
            // Convert the default number validation error message into a more general message
            if (error.path.at(-1) === 'value' && error.value === null && error.code === 'number.base') {
                error.code = 'any.empty';
            }

            return error;
        })
    );
}

export function formatQuantity(quantity: Quantity | null): string | null {
    if (!quantity || quantity.value === null || quantity.unit === null) {
        return null;
    }

    return `${quantity.value} ${quantity.unit}`;
}
